import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Divider, Stack, List, ListItem, ListItemText, Badge } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { getDisplayDate } from '../../util/dateTime';

interface Props {
    open: boolean;
    onClose: () => void;
}

const RiskDisclaimerDialog: React.FC<Props> = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            BackdropProps={{
                style: {
                    backdropFilter: 'blur(6px)',
                    backgroundColor: 'rgba(0,0,0,0.2)',
                },
            }}
            PaperProps={{
                style: {
                    borderRadius: 8,
                    width: '100%',
                    maxWidth: 600,
                  
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DescriptionIcon color="primary" />
                    <Typography variant="h6">Risk disclosures on derivatives</Typography>
                </Stack>
            </DialogTitle>

            <Divider />

            <DialogContent style={{marginLeft:"30px"}}>
                <ul style={{ margin: 0, listStyleType: 'disc', marginTop:"20px" }}>
                    <li style={{ marginBottom: 8 }}>
                        <Typography fontSize="16px" >
                            9 out of 10 individual traders in equity F&O incurred net losses.
                        </Typography>
                    </li>
                    <li style={{ marginBottom: 8,lineHeight: 1.5 }}>
                        <Typography fontSize="16px" >
                            On average, loss-makers registered net trading losses of over ₹50,000.
                        </Typography>
                    </li>
                    <li style={{ marginBottom: 8 }}>
                        <Typography fontSize="16px">
                            Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.
                        </Typography>
                    </li>
                    <li style={{ marginBottom: 8 }}>
                        <Typography fontSize="16px" >
                            Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.
                        </Typography>
                    </li>
                </ul>

                <Typography fontSize="10px">
                    Source: SEBI study dated January 25, 2023 on “Analysis of Profit and Loss of Individual Traders dealing in equity Futures and Options (F&O) Segment”, wherein Aggregate Level findings are based on annual Profit/Loss incurred by individual traders in equity F&O during FY 2021-22.
                </Typography>
            </DialogContent>

            <Divider />

            <DialogActions>
                <Button onClick={() => {
                    onClose();
                    localStorage.setItem('riskDiscloserCloseDate', getDisplayDate(Date.now()));
                }} variant="contained" color="primary">
                    I Understand
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export default RiskDisclaimerDialog;
